var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"order-button",style:(_vm.buttonCustom),attrs:{"href":"#","title":"Order Online!"},on:{"click":function($event){$event.preventDefault();return _vm.showOrderSystem.apply(null, arguments)}}},[_vm._v("\n  "+_vm._s(_vm.$t("label.order_online"))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }